var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8438 27.7656C19.3765 24.3636 23.6906 19.5034 27.0961 15.9734C28.5756 14.4403 29.4041 12.3679 29.4041 10.2102C29.4041 8.05263 28.5757 5.9803 27.0961 4.44714C25.6065 2.90247 23.578 2.03125 21.4588 2.03125C19.3396 2.03125 17.311 2.90255 15.8215 4.44737L15.4518 4.83061L15.0817 4.44714C11.9751 1.22684 6.914 1.22684 3.80733 4.44714C0.730891 7.6361 0.730891 12.7844 3.80733 15.9734L7.82812 19.75",
    stroke: "#1874FE",
    strokeWidth: 2.09281,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8438 20.5938L15.8438 29.1875",
    stroke: "#1874FE",
    strokeWidth: 2.0925
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 28.1875H15",
    stroke: "#1874FE",
    strokeWidth: 2.0925
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f70bb7552fce0b7eb044c8049593bec7.svg";
export { ForwardRef as ReactComponent };